// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AKW1O","col":"styles_col__1EMS9"};